<template>
  <div>
    <nav class="breadcrumb_box" aria-label="breadcrumb" v-if="CategoryData">
      <div class="container">
        <ol class="breadcrumb">
          <li class="breadcrumb-item"><router-link to="/" :title="$t('首頁')">{{ $t('首頁') }}</router-link></li>
          <li class="breadcrumb-item active" aria-current="page">{{ CategoryData.Category.CategoryName }}</li>
        </ol>
      </div>
    </nav>
    <template v-if="CategoryData && CategoryData.Category">
      <!-- 文章列表 -->
      <div class="wrapper list" v-if="CategoryData.Category.Type == 0">
        <section class="list_news">
          <div class="container">
            <div class="title_box">
              <h2>{{ CategoryData.Category.CategoryName }}</h2>
            </div>
            <div class="list_btn" v-if="CategoryData.Category.IsShowSub">
              <ul class="btn_box">
                <li><button class="btn" v-for="SubCategory in CategoryData.SubCategorys" :index="SubCategory.CId"
                    @click="CategoryTabIndex = SubCategory.CId"
                    :class="CategoryTabIndex == SubCategory.CId ? 'active' : ''">
                    <p>{{ SubCategory.CategoryName }}</p>
                  </button></li>
              </ul>
            </div>
            <ul class="list_main">
              <li v-for="Post in Posts" :key="Post.PId">
                <a href="javascript:void(0)" @click="gotoPost(Post)">
                  <div class="time">
                    <div class="rectangle_bg">
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                    </div>
                    <p>{{ Post.PublicStartTime | timeString("YYYY/MM/DD") }}</p>
                  </div>
                  <p>{{ Post.Title }}</p>
                </a>
              </li>
            </ul>
          </div>
          <nav class="page_box" aria-label="Page navigation example">
            <div class="container">
              <ul class="pagination">
                <li class="page-item">
                  <a class="page-link" href="javascript:void(0)" aria-label="Previous"
                    @click="pageNow - 1 >= 1 ? loadList(pageNow - 1) : loadList(pageNow)">
                    <span aria-hidden="true">&laquo;</span>
                  </a>
                </li>
                <!-- 第一頁 -->
                <li class="page-item" :class="{ disabled: pageNow === 1 }">
                  <a :class="pageNow == 1 ? 'page-link-active' : ''" class="page-link" href="javascript:void(0)"
                    @click="loadList(1)">1</a>
                </li>
                <!-- 左側省略號 -->
                <li v-if="startPage > 2" class="page-item disabled">
                  <a class="page-link">...</a>
                </li>
                <!-- 中間頁面 -->
                <li v-for="index in visiblePages" :key="index" class="page-item">
                  <a :class="pageNow == index ? 'page-link-active' : ''" class="page-link" href="javascript:void(0)"
                    @click="loadList(index)">
                    {{ index }}
                  </a>
                </li>
                <!-- 右側省略號 -->
                <li v-if="endPage < pageAll - 1" class="page-item disabled">
                  <a class="page-link">...</a>
                </li>
                <!-- 最後一頁 -->
                <li class="page-item" :class="{ disabled: pageNow === pageAll }" v-if="pageAll > 1">
                  <a :class="pageNow == pageAll ? 'page-link-active' : ''" class="page-link" href="javascript:void(0)"
                    @click="loadList(pageAll)">{{ pageAll }}</a>
                </li>
                <li class="page-item">
                  <a class="page-link" href="javascript:void(0)" aria-label="Next"
                    @click="pageNow + 1 <= pageAll ? loadList(pageNow + 1) : loadList(pageNow)">
                    <span aria-hidden="true">&raquo;</span>
                  </a>
                </li>
              </ul>
            </div>
          </nav>
        </section>
      </div><!-- wrapper -->
      <!-- 圖文列表 -->
      <div class="wrapper list list_2" v-if="CategoryData.Category.Type == 1">
        <section class="list_news">
          <div class="container">
            <div class="title_box">
              <h2>{{ CategoryData.Category.CategoryName }}</h2>
            </div>
            <ul class="list_main">
              <li v-for="Post in Posts" :key="Post.PId">
                <a href="javascript:void(0)" @click="gotoPost(Post)">
                  <div class="photo">
                    <div class="img_box">
                      <img v-if="Post.Image" :src="CategoryData.SiteUrl + Post.Image">
                      <img v-else src="img/default.png" alt="">
                    </div>
                  </div>
                  <div class="text">
                    <div class="time">
                      <div class="rectangle_bg">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                      </div>
                      <p>{{ Post.PublicStartTime | timeString("YYYY/MM/DD") }}</p>
                    </div>
                    <p>{{ Post.Title }}</p>
                  </div>
                </a>
              </li>
            </ul>
          </div>
          <nav class="page_box" aria-label="Page navigation example">
            <div class="container">
              <ul class="pagination">
                <li class="page-item">
                  <a class="page-link" href="javascript:void(0)" aria-label="Previous"
                    @click="pageNow - 1 >= 1 ? loadList(pageNow - 1) : loadList(pageNow)">
                    <span aria-hidden="true">&laquo;</span>
                  </a>
                </li>
                <!-- 第一頁 -->
                <li class="page-item" :class="{ disabled: pageNow === 1 }">
                  <a :class="pageNow == 1 ? 'page-link-active' : ''" class="page-link" href="javascript:void(0)"
                    @click="loadList(1)">1</a>
                </li>
                <!-- 左側省略號 -->
                <li v-if="startPage > 2" class="page-item disabled">
                  <a class="page-link">...</a>
                </li>
                <!-- 中間頁面 -->
                <li v-for="index in visiblePages" :key="index" class="page-item">
                  <a :class="pageNow == index ? 'page-link-active' : ''" class="page-link" href="javascript:void(0)"
                    @click="loadList(index)">
                    {{ index }}
                  </a>
                </li>
                <!-- 右側省略號 -->
                <li v-if="endPage < pageAll - 1" class="page-item disabled">
                  <a class="page-link">...</a>
                </li>
                <!-- 最後一頁 -->
                <li class="page-item" :class="{ disabled: pageNow === pageAll }" v-if="pageAll > 1">
                  <a :class="pageNow == pageAll ? 'page-link-active' : ''" class="page-link" href="javascript:void(0)"
                    @click="loadList(pageAll)">{{ pageAll }}</a>
                </li>
                <li class="page-item">
                  <a class="page-link" href="javascript:void(0)" aria-label="Next"
                    @click="pageNow + 1 <= pageAll ? loadList(pageNow + 1) : loadList(pageNow)">
                    <span aria-hidden="true">&raquo;</span>
                  </a>
                </li>
              </ul>
            </div>
          </nav>
        </section>
      </div><!-- wrapper -->
      <!-- 師資列表 -->
      <div class="wrapper list  list_3" v-if="CategoryData.Category.Type == 5">
        <section class="list_news">
          <div class="container">
            <div class="title_box title_box_b">
              <h2>{{ CategoryData.Category.CategoryName }}</h2>
            </div>
            <div class="list_btn">
              <ul class="btn_box">
                <li v-for="SubCategory in CategoryData.SubCategorys" :index="SubCategory.CId"><button class="btn"
                    @click="CategoryTabIndex = SubCategory.CId"
                    :class="CategoryTabIndex == SubCategory.CId ? 'active' : ''">
                    <p>{{ SubCategory.CategoryName }}</p>
                  </button></li>
              </ul>
            </div>
            <ul class="list_main show">
              <li v-for="Post in Posts" :key="Post.PId">
                <a href="javascript:void(0)" @click="gotoPost(Post)">
                  <div class="photo">
                    <div class="img_box">
                      <img v-if="Post.Image" :src="CategoryData.SiteUrl + Post.Image">
                      <img v-else src="img/default.png" alt="">
                    </div>
                  </div>
                  <div class="text">
                    <p>{{ Post.Title }}</p>
                    <p>{{ Post.JobName }}</p>
                  </div>
                </a>
              </li>
            </ul>
          </div>
          <nav class="page_box" aria-label="Page navigation example">
            <div class="container">
              <ul class="pagination">
                <li class="page-item">
                  <a class="page-link" href="javascript:void(0)" aria-label="Previous"
                    @click="pageNow - 1 >= 1 ? loadList(pageNow - 1) : loadList(pageNow)">
                    <span aria-hidden="true">&laquo;</span>
                  </a>
                </li>
                <!-- 第一頁 -->
                <li class="page-item" :class="{ disabled: pageNow === 1 }">
                  <a :class="pageNow == 1 ? 'page-link-active' : ''" class="page-link" href="javascript:void(0)"
                    @click="loadList(1)">1</a>
                </li>
                <!-- 左側省略號 -->
                <li v-if="startPage > 2" class="page-item disabled">
                  <a class="page-link">...</a>
                </li>
                <!-- 中間頁面 -->
                <li v-for="index in visiblePages" :key="index" class="page-item">
                  <a :class="pageNow == index ? 'page-link-active' : ''" class="page-link" href="javascript:void(0)"
                    @click="loadList(index)">
                    {{ index }}
                  </a>
                </li>
                <!-- 右側省略號 -->
                <li v-if="endPage < pageAll - 1" class="page-item disabled">
                  <a class="page-link">...</a>
                </li>
                <!-- 最後一頁 -->
                <li class="page-item" :class="{ disabled: pageNow === pageAll }" v-if="pageAll > 1">
                  <a :class="pageNow == pageAll ? 'page-link-active' : ''" class="page-link" href="javascript:void(0)"
                    @click="loadList(pageAll)">{{ pageAll }}</a>
                </li>
                <li class="page-item">
                  <a class="page-link" href="javascript:void(0)" aria-label="Next"
                    @click="pageNow + 1 <= pageAll ? loadList(pageNow + 1) : loadList(pageNow)">
                    <span aria-hidden="true">&raquo;</span>
                  </a>
                </li>
              </ul>
            </div>
          </nav>
        </section>
      </div><!-- wrapper -->
    </template>
  </div>
</template>

<script>
import Vue from "vue";

import axios from "axios";
import VueAxios from "vue-axios";
Vue.use(VueAxios, axios);

import VueI18n from "vue-i18n";
Vue.use(VueI18n);

const messages = {
  zh_tw: {
    "首頁": "首頁",
  },
  en: {
    "首頁": "Home",
  },
};

const i18n = new VueI18n({
  locale: "zh_tw",
  messages,
});

import AES from "@/utils/aes.js";
import Validate from "@/utils/validate.js";

import Slick from "vue-slick";

export default {
  name: "Category",
  i18n,
  components: {
    Slick,
  },
  data() {
    return {
      CategoryData: null,
      local: "zh_tw",
      CategoryTabIndex: -1,
      PostTabIndex: -1,
      Keyword: "",
      Posts: null,
      pageAll: 0,
      perPage: 10,
      pageNow: 1,
      total: 0,
      maxVisiblePages: 5,
    };
  },
  computed: {
    // 計算顯示範圍的起始頁
    startPage() {
      const half = Math.floor(this.maxVisiblePages / 2);
      return Math.max(2, this.pageNow - half); // 從第2頁開始
    },
    // 計算顯示範圍的結束頁
    endPage() {
      const half = Math.floor(this.maxVisiblePages / 2);
      return Math.min(this.pageAll - 1, this.pageNow + half); // 到倒數第2頁為止
    },
    // 中間可見頁面
    visiblePages() {
      const pages = [];
      for (let i = this.startPage; i <= this.endPage; i++) {
        pages.push(i);
      }
      return pages;
    },
  },
  watch: {
    CategoryTabIndex(newValue, oldValue) {
      if (this.CategoryData.Category.Type == 5) {
        this.loadList(1);
      }
    }
  },
  beforeRouteUpdate(to, from, next) {
    Vue.axios
      .get(
        this.$store.state.src +
        this.$store.state.subDirectory +
        "/GCIT/Category",
        {
          params: { CId: to.params.CId, lang: $cookies.get("gcit_the_site_lang") },
        }
      )
      .then((response) => {
        this.CategoryData = response.data;
        this.Keyword = "";
        this.pageNow = 1;
        this.CategoryTabIndex = -1;
        if (this.CategoryData.Category.Type == 0) {
          if (this.CategoryData.Category.IsShowSub && this.CategoryData.SubCategorys.length > 0) {
            this.CategoryTabIndex = this.CategoryData.SubCategorys[0].CId;
          }
          this.perPage = 5;
          this.loadList(this.pageNow);
        } else if (this.CategoryData.Category.Type == 1) {
          this.perPage = 6;
          this.loadList(this.pageNow);
        } else if (this.CategoryData.Category.Type == 5 && this.CategoryData.SubCategorys.length > 0) {
          if (this.CategoryData.SubCategorys.length > 0) {
            this.CategoryTabIndex = this.CategoryData.SubCategorys[0].CId;
          }
          this.loadList(this.pageNow);
        }
      })
      .catch((error) => {
        console.log(error);
      });
    next();
  },
  created: function () {
    Vue.axios
      .get(
        this.$store.state.src +
        this.$store.state.subDirectory +
        "/GCIT/Category",
        {
          params: { CId: this.$route.params.CId, lang: $cookies.get("gcit_the_site_lang") },
        }
      )
      .then((response) => {
        this.CategoryData = response.data;
        this.Keyword = "";
        this.pageNow = 1;
        this.CategoryTabIndex = -1;
        if (this.CategoryData.Category.Type == 0) {
          this.perPage = 5;
          this.loadList(this.pageNow);
        } else if (this.CategoryData.Category.Type == 1) {
          this.perPage = 6;
          this.loadList(this.pageNow);
        } else if (this.CategoryData.Category.Type == 5) {
          if (this.CategoryData.SubCategorys.length > 0) {
            this.CategoryTabIndex = this.CategoryData.SubCategorys[0].CId;
          }
          this.loadList(this.pageNow);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  },
  mounted: function () {
    if ($cookies.isKey("gcit_the_site_lang")) {
      i18n.locale = $cookies.get("gcit_the_site_lang");
      this.local = $cookies.get("gcit_the_site_lang");
    } else {
      i18n.locale = $cookies.get("gcit_the_site_lang");
      this.local = "zh_tw";
    }
  },
  updated: function () {
  },
  methods: {
    loadList: function (page) {
      var that = this;
      $.ajax({
        url:
          this.$store.state.src +
          this.$store.state.subDirectory +
          "/GCIT/PostList",
        type: "post",
        data: {
          CId: this.$route.params.CId,
          SubCId: that.CategoryTabIndex,
          Keyword: that.Keyword,
          page: page,
          perPage: that.perPage,
          lang: $cookies.get("gcit_the_site_lang"),
        },
        dataType: "json",
        error: function () { },
        success: function (res) {
          if (res.status == 1) {
            that.total = res.total;
            that.pageNow = page;
            that.Posts = res.Posts;
            that.perPage = res.perPage;
            that.pageAll = Math.max(Math.ceil(res.total / that.perPage), 1);
            // $('html, body').animate({
            //   scrollTop: $('#list_posts').offset().top
            // }, 0);
          }
        },
      });
    },
    gotoPost(Post) {
      if (Post.Type == 1) {
        if (Post.Blank) {
          window.open(Post.Url, "_blank");
        } else {
          location.href = Post.Url;
        }
      } else if (Post.Type == 5) {
        window.open(Post.TeacherUrl, "_blank");
      } else {
        this.$router.push({
          name: "Post",
          params: { PId: Post.PId, CId: this.CategoryData.Category.CId },
        });
      }
    },
    gotoUrl: function (Url, Blank) {
      if (Blank) {
        window.open(Url, "_blank");
      } else {
        location.href = Url;
      }
    },
  },
};
</script>
